// third party
import { createSlice } from "@reduxjs/toolkit";

// project imports
import axios from "utils/axios";
import { dispatch } from "../index";

// ==============================|| SLICE - USER MANAGEMENT ||============================== //

const initialState = {
  error: null,
  users: [],
  loading: false,
};

const slice = createSlice({
  name: "userManagement",
  initialState,
  reducers: {
    // HAS ERROR
    hasError(state, action) {
      state.error = action.payload;
      state.loading = false;
    },

    // SET LOADING
    setLoading(state, action) {
      state.loading = action.payload;
    },

    // GET USERS
    getUsersSuccess(state, action) {
      state.users = action.payload;
      state.loading = false;
    },

    // CREATE USER
    createUserSuccess(state, action) {
      state.users.push(action.payload);
      state.loading = false;
    },

    // UPDATE USER
    updateUserSuccess(state, action) {
      const index = state.users.findIndex(
        (user) => user.id === action.payload.id,
      );
      if (index !== -1) {
        state.users[index] = action.payload;
      }
      state.loading = false;
    },

    // DELETE USER
    deleteUserSuccess(state, action) {
      state.users = state.users.filter((user) => user.id !== action.payload);
      state.loading = false;
    },
  },
});

// Reducer
export default slice.reducer;

// ==============================|| SLICE - USER MANAGEMENT ACTIONS ||============================== //

export function getUsers() {
  return async () => {
    try {
      dispatch(slice.actions.setLoading(true));
      const response = await axios.get("/admin/users");
      dispatch(slice.actions.getUsersSuccess(response.data.users));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function createUser(userData) {
  return async () => {
    try {
      dispatch(slice.actions.setLoading(true));
      const response = await axios.post("/admin/users", userData);
      dispatch(slice.actions.createUserSuccess(response.data.user));
      return response.data.user;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      throw error;
    }
  };
}

export function updateUser(userId, userData) {
  return async () => {
    try {
      dispatch(slice.actions.setLoading(true));
      const response = await axios.put(`/admin/users/${userId}`, userData);
      dispatch(slice.actions.updateUserSuccess(response.data.user));
      return response.data.user;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      throw error;
    }
  };
}

export function sendResetEmail(userId) {
  return async () => {
    try {
      const response = await axios.post(
        `/admin/users/${userId}/send-reset-email`,
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  };
}

export function sendWelcomeEmail(userId) {
  return async () => {
    try {
      const response = await axios.post(
        `/admin/users/${userId}/send-welcome-email`,
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  };
}

export function sendCustomEmail(userId, subject, message) {
  return async () => {
    try {
      const response = await axios.post(`/admin/send-custom-email/${userId}`, {
        subject,
        message,
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  };
}

export function deleteUser(userId) {
  return async () => {
    try {
      dispatch(slice.actions.setLoading(true));
      await axios.delete(`/admin/users/${userId}`);
      dispatch(slice.actions.deleteUserSuccess(userId));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      throw error;
    }
  };
}
